var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMenuFavoriteFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.542 4.13c-2.744-.024-5.157 1.37-6.498 3.47-1.293-2.125-3.68-3.576-6.425-3.6-4.16-.047-7.57 3.175-7.618 7.2C1.89 20.55 15.798 29 15.798 29s14.092-8.168 14.19-17.517c.05-4.013-3.298-7.306-7.458-7.353",
    fill: "#228622"
  })));
}

export default SvgIconMenuFavoriteFilled;